// extracted by mini-css-extract-plugin
export default {"NoGraphData":"NoGraphData_NoGraphData__kddle","noData":"NoGraphData_noData__RclY3","nodatasub":"NoGraphData_nodatasub__idJiz"};